
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("edmwx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4c74bf758213d1e282c9b5bf31f6b0ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a593c059010f3c9e$var$_react = $a593c059010f3c9e$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $a593c059010f3c9e$var$_iconNew = $a593c059010f3c9e$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $a593c059010f3c9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LobbyBell".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/lobby-bell
 * Usage guidance:
 * Multi purpose - Known uses: risks in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a593c059010f3c9e$var$LobbyBellIcon = (props)=>/*#__PURE__*/ $a593c059010f3c9e$var$_react.default.createElement($a593c059010f3c9e$var$_iconNew.default, Object.assign({
        name: "LobbyBellIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h4v1.5H8.75v1.75h.92a4.75 4.75 0 0 1 4.72 4.225l.355 3.192A.75.75 0 0 1 14 12.5H2a.75.75 0 0 1-.745-.833l.354-3.192A4.75 4.75 0 0 1 6.33 4.25h.92V2.5H6zm.33 4.75A3.25 3.25 0 0 0 3.1 8.641L2.838 11h10.324L12.9 8.641A3.25 3.25 0 0 0 9.67 5.75zM15 13.5V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$a593c059010f3c9e$var$LobbyBellIcon.displayName = 'LobbyBellIcon';
var $a593c059010f3c9e$var$_default = module.exports.default = $a593c059010f3c9e$var$LobbyBellIcon;

});


//# sourceMappingURL=lobby-bell.7ab3f812.js.map
